import React from "react";
import Container from "@material-ui/core/Container";
import FirstName from "../formInputs/FirstName";
import Button from "@material-ui/core/Button";

export const Names = ({ formData, setForm, navigation }) => {
  const { firstName, lastName } = formData;

  return (
    <Container maxWidth="xs" className="mt-20">
      <h1 className="py-20 text-3xl text-blue-900">How can we reach you?</h1>
      <div>
        <label
          htmlFor="firstName"
          className="block text-sm font-medium text-gray-700"
        >
          First Name
        </label>
        <div className="mt-1">
          <input
            name="firstName"
            value={firstName}
            onChange={setForm}
            id="firstName"
            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            placeholder="John Doe"
          />
        </div>
      </div>
      <div className="mt-6">
        <label
          htmlFor="lastName"
          className="block text-sm font-medium text-gray-700"
        >
          Last Name
        </label>
        <div className="mt-1">
          <input
            name="lastName"
            value={lastName}
            onChange={setForm}
            id="lastName"
            className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
            placeholder="John Doe"
          />
        </div>
      </div>
      <div style={{ marginTop: "1rem" }}>
        <Button
          color="secondary"
          variant="contained"
          style={{ marginRight: "1rem" }}
          onClick={() => navigation.previous()}
        >
          Back
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => navigation.next()}
        >
          Next
        </Button>
      </div>
    </Container>
  );
};
